import { useState } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import LMPEnergyChart from './LMPEnergyChart';
import LMPORChart from './LMPORChart';

export default function CombLMPEnergyORCharts({ site, startDate, endDate, msSessionInfo, refreshKey }) {
    const [expandedChart, setExpandedChart] = useState(null);

    const isLMPEnergyExpanded = expandedChart === 'lmpEnergy';
    const isLMPORExpanded = expandedChart === 'lmpOR';

    const handleLMPEnergyToggle = () => {
        setExpandedChart(prev => {
            const next = prev === 'lmpEnergy' ? null : 'lmpEnergy';
            setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
            return next;
        });
    };

    const handleLMPORToggle = () => {
        setExpandedChart(prev => {
            const next = prev === 'lmpOR' ? null : 'lmpOR';
            setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
            return next;
        });
    };


    return (
        <Grid container spacing={3}>
            <Grid
                item
                xs={12}
                md={isLMPEnergyExpanded ? 12 : 6}
                lg={isLMPEnergyExpanded ? 12 : 6}
                style={{ display: isLMPORExpanded ? 'none' : 'block' }}
            >
                <LMPEnergyChart
                    key={`lmpEnergy-${refreshKey}`}
                    site={site}
                    startDate={startDate}
                    endDate={endDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handleLMPEnergyToggle}
                    refreshKey={refreshKey}
                />
            </Grid>

            <Grid
                item
                xs={12}
                md={isLMPORExpanded ? 12 : 6}
                lg={isLMPORExpanded ? 12 : 6}
                style={{ display: isLMPEnergyExpanded ? 'none' : 'block' }}
            >
                <LMPORChart
                    key={`lmpOR-${refreshKey}`}
                    site={site}
                    startDate={startDate}
                    endDate={endDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handleLMPORToggle}
                    refreshKey={refreshKey}
                />
            </Grid>
        </Grid>
    );
}

CombLMPEnergyORCharts.propTypes = {
    site: PropTypes.object.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    msSessionInfo: PropTypes.object.isRequired,
    refreshKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};